/**
 * Modified from json-stable-stringify
 * https://www.npmjs.com/package/json-stable-stringify
 */
export function stableStringify(obj: any) {
	const seen: any[] = []

	function stringify(node: any, level: number) {
		if (node?.toJSON && typeof node.toJSON === "function") {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			node = node.toJSON()
		}

		if (node === undefined) {
			return
		}

		if (typeof node !== "object" || node === null) {
			return JSON.stringify(node)
		}

		if (Array.isArray(node)) {
			const out: string[] = []
			for (let i = 0; i < node.length; i++) {
				out.push(stringify(node[i], level + 1) || JSON.stringify(null))
			}
			return "[" + out.join(",") + "]"
		}

		if (seen.indexOf(node) !== -1) {
			throw new TypeError("Converting circular structure to JSON")
		} else {
			seen.push(node)
		}

		const keys = Object.keys(node).sort()
		const out: string[] = []
		for (let i = 0; i < keys.length; i++) {
			const key = keys[i] as keyof typeof node
			const value = stringify(node[key], level + 1)

			if (!value) {
				continue
			}

			const keyValue = JSON.stringify(key) + ":" + value

			out.push(keyValue)
		}

		seen.splice(seen.indexOf(node), 1)

		return "{" + out.join(",") + "}"
	}

	return stringify(obj, 0) ?? ""
}
